import script from "./form-privacy-consent-field.vue?vue&type=script&lang=ts&setup=true"
export * from "./form-privacy-consent-field.vue?vue&type=script&lang=ts&setup=true"

import "./form-privacy-consent-field.vue?vue&type=style&index=0&id=d771a216&lang=css"

const __exports__ = script;

export default __exports__